import { Box, Flex, Text, TextProps } from '@chakra-ui/react'

export const Labels = ({ children, ...props }: TextProps) => (
  <Text
    position="absolute"
    color="white"
    height="188px"
    fontSize="14px"
    bottom="0px"
    left="50%"
    transformOrigin="bottom center"
    {...props}
  >
    {children}
  </Text>
)

export const Dial = ({
  hasValue,
  semiCircleClipPath,
}: {
  hasValue: Boolean
  semiCircleClipPath: string[]
}) => {
  return (
    <Box
      height="100%"
      width="100%"
      position="absolute"
      as="div"
      borderRadius="165px 165px 0 0"
      clipPath={`polygon(100% 50%, 100% 100%, 0 101%, 0 0, 100% 0, 100% 50%, ${semiCircleClipPath.join(
        ',',
      )})`}
      background={
        hasValue
          ? `conic-gradient( from 4.7rad at 50% 100%, #BC2970, #FF5C65 36deg, #FD9982 72deg, #F8C268 108deg, #6CCE81 144deg )`
          : '#426C79'
      }
    />
  )
}

export const Needle = ({ value }: { value: number }) => (
  <Box
    transform={`rotate(${180 * value * 0.01}deg)`}
    position="absolute"
    height="5px"
    width="0"
    left="0"
    right="0"
    margin="auto"
    transformOrigin="center center"
    bottom="0px"
  >
    <Box
      borderColor="transparent white"
      borderStyle="solid"
      borderWidth="5px 0px 5px 125px"
      transform="rotate(180deg)"
      width="80%"
      marginLeft="-120px"
    />
  </Box>
)

export const GaugeReading = ({ value }: { value: number }) => (
  <Flex
    position="absolute"
    justifyContent="center"
    color="white"
    width="100%"
    bottom="-26px"
    fontWeight={700}
    fontSize="14px"
  >
    {value}%
  </Flex>
)

export const ErrorMessage = () => (
  <Flex
    position="relative"
    justifyContent="center"
    color="white"
    width="100%"
    fontSize="11px"
    bottom="-124px"
    fontWeight={700}
  >
    No Data Available
  </Flex>
)
